module.exports = __webpack_public_path__ + "img/thumbsup.a66f09e8.svg";